import React from "react";
import { Link } from "react-router-dom";

import Grid from "material-ui/Grid";
import Paper from "material-ui/Paper";
import Typography from "material-ui/Typography";
import { withStyles, createStyleSheet } from "material-ui/styles";
import Divider from "material-ui/Divider";

const styleSheet = createStyleSheet("Api", (theme) => ({
  row: {
    padding: "10px 20px",
    "& h3": {
      fontSize: "16px",
      lineHeight: "24px",
    },
  },
  [theme.breakpoints.up("md")]: {
    row: {
      "& h3": {
        fontSize: "24px",
        lineHeight: "32px",
      },
    },
  },
  cellHeader: {
    fontWeight: "bold",
    fontSize: 16,
    minWidth: 350,
    maxWidth: 350,
  },
  apiList: {
    listStyleType: "none",
    margin: 0,
    padding: "0 0 0 16px",
    "& li": {
      fontSize: 16,
      marginBottom: 15,
      "& ul": {
        listStyleType: "none",
        paddingLeft: 20,
      },
      "& li": {
        marginBottom: 10,
        fontSize: 14,
      },
    },
    "& code": {
      fontSize: 12,
    },
  },
}));

const authInfo = [
  {
    name: "X-Prerender-Token",
    messages: [<code>curl --header "X-Prerender-Token: secret-token"</code>],
  },
];

const optionalHeaders = [];

const renderApiInfo = (apiFeatures, props) => {
  return apiFeatures.map((apiFeature, i) => {
    if (apiFeature.isSubtitle) {
      return (
        <div key={i}>
          <Grid container className={props.classes.row}>
            <Grid item xs={12} sm={12} className={props.classes.cellHeader}>
              <h4 style={{ margin: 0 }}>{apiFeature.title}</h4>
            </Grid>
          </Grid>
        </div>
      );
    }
    const messages = apiFeature.messages.map((message, i) => {
      return <li key={i}>{message}</li>;
    });
    return (
      <div key={i}>
        <Grid container className={props.classes.row}>
          <Grid item xs={12} sm={12} className={props.classes.cellHeader}>
            <code>{apiFeature.name}</code>
          </Grid>
          <Grid item xs={12} sm>
            <ul className={props.classes.apiList}>{messages}</ul>
          </Grid>
        </Grid>
        <Divider />
      </div>
    );
  });
};

const Api = (props) => {
  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <Paper>
            <Grid container className={props.classes.row}>
              <Grid item xs={12}>
                <p>
                  <strong>Endpoint:</strong>{" "}
                  <code>service.headless-render-api.com/api/v1</code>
                </p>
                <p>
                  This administrative API is for operations related to your
                  account, see the <Link to="/docs/api">pre-rendering API</Link>{" "}
                  for documenation on pre-rendering and screenshots.
                </p>
              </Grid>
            </Grid>
          </Paper>
          <h2>Auth</h2>
          <Paper>
            <Grid container className={props.classes.row}>
              <Grid item xs={12}>
                Your API token via HTTP header is required for any
                administrative API commands (unlike the pre-rendering API)
              </Grid>
            </Grid>
            {renderApiInfo(authInfo, props)}
          </Paper>
          <h2>Clearing server cache</h2>
          <p>
            By default, headless-render-api.com caches for 5 minutes. This is
            configurable for each API request (see the
            <code>Prerender-Cache-Duration</code> header in the{" "}
            <Link to="/docs/api">pre-rendering API docs</Link>
          </p>
          <p>
            This <code>POST</code> request will clear headless-render-api.com's
            cache for URLs hit by your account. Some headless-render-api.com
            users set their <code>Prerender-Cache-Duration</code> value to long
            periods (e.g. 1 month) and sometimes want an easy way to clear all
            cache.
          </p>
          <Paper>
            <Grid container className={props.classes.row}>
              <Grid item xs={12}>
                <Typography type="subheading">
                  <strong>POST</strong>{" "}
                  https://service.headless-render-api.com/api/v1/clear-cache
                </Typography>
                <code>
                  curl -XPOST -H'X-Prerender-Token: SECRET_API_TOKEN'
                  http://service.headless-render-api.com/api/v1/clear-cache
                </code>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styleSheet)(Api);



// WEBPACK FOOTER //
// ./src/AdminApi.js